import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { useEffect, useState, useRef } from 'react';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Transactions from './pages/Transactions';
import TaskBoard from './pages/TaskBoard';
import Accounts from './pages/Accounts';
import Goals from './pages/Goals';
import Investments from './pages/Investments';
import Reports from './pages/Reports';
import Profile from './pages/Profile';
import Settings from './pages/Settings';
import Admin from './pages/Admin';
import SubscriptionBlocked from './pages/SubscriptionBlocked';
import ChangePassword from './pages/ChangePassword';
import PaymentSuccess from './pages/PaymentSuccess';
import PaymentCancelled from './pages/PaymentCancelled';
import LandingPage from './pages/LandingPage';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import AuthCallback from './components/AuthCallback';
import ProtectedRoute from './components/ProtectedRoute';
import AdminRoute from './components/AdminRoute';
import Layout from './components/Layout';
import { Toaster } from './components/ui/sonner';
import SubscriptionGuard from './components/SubscriptionGuard';
import './App.css';

function AppRouter() {
  const location = useLocation();
  
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  return (
    <Routes>
      {/* Landing Page as Home */}
      <Route path="/" element={<LandingPage />} />
      <Route path="/sobre" element={<LandingPage />} />
      <Route path="/login" element={<Login />} />
      <Route path="/termos" element={<Terms />} />
      <Route path="/privacidade" element={<Privacy />} />
      <Route path="/subscription-blocked" element={<SubscriptionBlocked />} />
      <Route path="/change-password" element={<ChangePassword />} />
      <Route path="/payment-success" element={<PaymentSuccess />} />
      <Route path="/payment-cancelled" element={<PaymentCancelled />} />
      
      {/* Admin Route */}
      <Route path="/admin" element={
        <AdminRoute>
          <Admin />
        </AdminRoute>
      } />
      
      {/* Protected User Routes */}
      <Route path="/dashboard" element={
        <ProtectedRoute>
          <Layout>
            <Dashboard />
          </Layout>
        </ProtectedRoute>
      } />
      <Route path="/transactions" element={
        <ProtectedRoute>
          <Layout>
            <Transactions />
          </Layout>
        </ProtectedRoute>
      } />
      <Route path="/tasks" element={
        <ProtectedRoute>
          <Layout>
            <TaskBoard />
          </Layout>
        </ProtectedRoute>
      } />
      <Route path="/accounts" element={
        <ProtectedRoute>
          <Layout>
            <Accounts />
          </Layout>
        </ProtectedRoute>
      } />
      <Route path="/goals" element={
        <ProtectedRoute>
          <Layout>
            <Goals />
          </Layout>
        </ProtectedRoute>
      } />
      <Route path="/investments" element={
        <ProtectedRoute>
          <Layout>
            <Investments />
          </Layout>
        </ProtectedRoute>
      } />
      <Route path="/reports" element={
        <ProtectedRoute>
          <Layout>
            <Reports />
          </Layout>
        </ProtectedRoute>
      } />
      <Route path="/profile" element={
        <ProtectedRoute>
          <Layout>
            <Profile />
          </Layout>
        </ProtectedRoute>
      } />
      <Route path="/settings" element={
        <ProtectedRoute>
          <Layout>
            <Settings />
          </Layout>
        </ProtectedRoute>
      } />
    </Routes>
  );
}

function App() {
  useEffect(() => {
    // Load pixel config from backend and initialize tracking
    const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
    fetch(`${BACKEND_URL}/api/api/public/pixel-config`)
      .then(res => res.json())
      .then(config => {
        // Initialize Meta Pixel
        if (config.meta_pixel_id && window.fbq) {
          window.fbq('init', config.meta_pixel_id);
          window.fbq('track', 'PageView');
        }
        // Initialize Google Tag
        if (config.google_tag_id) {
          const script = document.createElement('script');
          script.async = true;
          script.src = `https://www.googletagmanager.com/gtag/js?id=${config.google_tag_id}`;
          document.head.appendChild(script);
          window.dataLayer = window.dataLayer || [];
          function gtag() { window.dataLayer.push(arguments); }
          gtag('js', new Date());
          gtag('config', config.google_tag_id);
        }
      })
      .catch(() => {}); // Silently fail if config not available
  }, []);

  return (
    <div className="App">
      <Router>
        <AppRouter />
        <SubscriptionGuard />
      </Router>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
